import React from 'react';

import { FlashCardQuizBlockData } from 'api/cms';
import { AmpHeroBlock } from 'cms/blocks/Amp/AmpHeroBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpFlashCardQuizBlock({
  content,
  data,
  blockId,
}: AmpBlockMappingComponentProps<FlashCardQuizBlockData>) {
  return (
    <AmpHeroBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        text: data.cards[0].question,
        // @ts-expect-error fix me
        image: data.cards[0].image,
        buttonText: getText('View Quiz'),
      }}
    />
  );
}
